
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let u = navigator.userAgent;
		let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		let device= isAndroid?"H5_ANDROID":"H5_IOS"
		let APIS = {
			//创建订单
			createOrder:{
				custom: true,
				url:(data:any)=>`/apis/moyin-account/activity/user/callback/createOrder?jsCode=${data.jsCode}&packageId=${data.packageId}&date=${data.date}&payType=${data.payType}&phone=${data.phone}`,
				method: 'post',
			},
			// 获取套餐信息
			getPackageInfo: {
				custom: true,
				url: `/apis/moyin-account/activity/user/callback/packageInfos`,
				method: 'get'
			},
			// 订单查询状态
			queryOrderStatus:{
				custom: true,
				url:`/apis/moyin-account/activity/user/callback/orderStatus`,
				method: 'get',
			},
			//最近购买记录
			getRecentOrder:{
				custom: true,
				url: `/apis/moyin-account/activity/user/callback/recentPaidList`,
				method: 'get'
			},
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"recallPage"
			})
		}